export const CURRENT_CONFIG = {

  // license
  appId: import.meta.env.VITE_APP_ID || '184115', // https://developer.dji.com/user/apps/#all
  appKey: import.meta.env.VITE_APP_KEY || 'a8fc2f61f481d35c24ef0e6ac95bea1', // https://developer.dji.com/user/apps/#all
  appLicense: import.meta.env.VITE_APP_LICENSE || 'SCpMLoa7FyLk+9gm/NLb+tvXZDMSUtiGhOOi5NyBF9FoPBWqB9ELYj+ydRCzGs1riyIJ2L8dPkbkQw6geabi6r0RMn9jFA+xlIi468VtbuXwBq6ogHytM4i+SBj8AiaGR8She/Omjlb/fgliQiX527L3+tehgxCeA80rjSE5gXQ=', // https://developer.dji.com/user/apps/#all

  // http
  baseURL: window.location.protocol + '//' + window.location.host,
  websocketURL: (window.location.protocol === 'https:' ? 'wss://' : 'ws://') + window.location.host + '/api/v1/ws',

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // Using Leaflet.js + OpenStreetMap (no API key required!)
  // If you want to switch to Google Maps later, enter the key below:
  googleMapsKey: '',

}
